import React, { useEffect, useState, useCallback } from "react";
import { ReceiptText, X, Check } from "lucide-react";
import api, { formatIDR } from "../lib/api";
import { toast } from "sonner";

// Popup approval pemakaian uang jalan TANPA struk/bon dari absensi.deteksipipabocor.com.
// Approve = pemakaian tetap tercatat; Tolak = nilai pemakaian dihapus (saldo teknisi kembali).
// "Nanti" hanya menyembunyikan di sesi ini.
const TravelExpenseApprovalPopup = () => {
  const [items, setItems] = useState([]);
  const [snoozed, setSnoozed] = useState([]);
  const [busy, setBusy] = useState(false);
  const [note, setNote] = useState("");

  const load = useCallback(() => {
    api.get("/travel-expense-approvals/pending").then((r) => setItems(r.data || [])).catch(() => {});
  }, []);

  useEffect(() => {
    load();
    const iv = setInterval(load, 20000);
    return () => clearInterval(iv);
  }, [load]);

  const decide = async (x, action) => {
    setBusy(true);
    try {
      await api.post(`/travel-expense-approvals/${x.id}`, { action, note });
      setItems((prev) => prev.filter((i) => i.id !== x.id));
      setNote("");
      toast.success(action === "approve" ? `Pemakaian ${x.technician_name} disetujui` : `Pemakaian ${x.technician_name} ditolak & dihapus`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Gagal menyimpan keputusan");
      load();
    } finally {
      setBusy(false);
    }
  };

  const visible = items.filter((x) => !snoozed.includes(x.id));
  if (!visible.length) return null;
  const x = visible[0];
  const color = "#D97706";

  return (
    <div className="fixed inset-0 z-[61] bg-black/40 flex items-center justify-center p-4" data-testid="travel-expense-approval-popup">
      <div className="bg-white w-full max-w-md border-2 shadow-2xl" style={{ borderColor: color }}>
        <div className="flex items-center justify-between px-4 py-3 text-white" style={{ backgroundColor: color }}>
          <div className="flex items-center gap-2 font-heading font-bold">
            <ReceiptText size={20} /> Approval Uang Jalan Tanpa Bon
          </div>
          <button onClick={() => setSnoozed((p) => [...p, x.id])} className="p-1 hover:bg-white/20" aria-label="Tutup"><X size={18} /></button>
        </div>
        <div className="p-4 space-y-2 text-sm">
          <p>
            <span className="font-bold">{x.technician_name}</span> mencatat pemakaian uang jalan{" "}
            <span className="font-bold">tanpa struk/bon</span>
            {x.trip_destination ? <> (perjalanan <span className="font-bold">{x.trip_destination}</span>)</> : null}:
          </p>
          <div className="border border-[#E4E4E7] p-3 space-y-1">
            <div className="flex items-center justify-between gap-3">
              <span className="font-mono text-xs text-[#52525B]">{x.date}</span>
              <span className="font-mono font-bold text-lg" style={{ color }}>{formatIDR(x.amount)}</span>
            </div>
            <div className="break-words">{x.purpose}</div>
            <div className="text-xs text-[#52525B] break-words">
              <span className="font-bold uppercase text-[10px] tracking-wider">Alasan tanpa bon:</span> {x.no_receipt_reason || "-"}
            </div>
          </div>
          <input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Catatan (opsional)"
            className="w-full border border-[#E4E4E7] px-3 py-2 text-sm" />
          <p className="text-xs text-[#52525B]">Jika ditolak, nilai pemakaian ini dihapus dan saldo uang jalan teknisi kembali bertambah.</p>
          {visible.length > 1 && <p className="text-xs text-[#52525B]">+{visible.length - 1} pemakaian lain menunggu</p>}
        </div>
        <div className="flex gap-2 px-4 pb-4">
          <button disabled={busy} onClick={() => decide(x, "approve")} data-testid="travel-expense-approve"
            className="flex-1 inline-flex items-center justify-center gap-2 bg-[#059669] text-white px-3 py-2 text-xs font-bold uppercase tracking-wider hover:bg-[#059669]/90 disabled:opacity-60">
            <Check size={14} /> Approve
          </button>
          <button disabled={busy} onClick={() => decide(x, "reject")} data-testid="travel-expense-reject"
            className="px-3 py-2 text-xs font-bold uppercase tracking-wider border border-[#DC2626] text-[#DC2626] hover:bg-[#DC2626]/5 disabled:opacity-60">
            Tolak & Hapus
          </button>
          <button onClick={() => setSnoozed((p) => [...p, x.id])}
            className="px-3 py-2 text-xs font-bold uppercase tracking-wider border border-[#E4E4E7] hover:bg-[#F4F4F5]">
            Nanti
          </button>
        </div>
      </div>
    </div>
  );
};

export default TravelExpenseApprovalPopup;
